/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_MEETINGS (state, meetings) {
    state.meetings = meetings
  },
  SET_MEETING_TYPES(state, types) {
    state.Attended = types.Attended
    state.Accepted = types.Accepted
    state.Canceled = types.Canceled
    state.Pending = types.Pending
    state.Rejected = types.Rejected
  },
  REMOVE_RECORD (state, itemId) {
    const meetingIndex = state.meetings.findIndex((u) => u.MeetingId === itemId)
    state.meetings.splice(meetingIndex, 1)
  }
}
